@if (isOpen()) {
  <!-- ── Backdrop ───────────────────────────────────────────────────────── -->
  <div
    class="iv-backdrop"
    (click)="close()"
    aria-label="Cerrar visor de imagen"
    role="button">
  </div>

  <!-- ── Panel principal ──────────────────────────────────────────────── -->
  <div class="iv-panel" role="dialog" aria-modal="true" [attr.aria-label]="config()?.title || 'Visor de imagen'">

    <!-- ── Barra de herramientas superior ─────────────────────────── -->
    <div class="iv-toolbar">
      <!-- Información de la imagen -->
      <div class="iv-info">
        @if (config()?.title) {
          <span class="iv-title">{{ config()!.title }}</span>
        }
        @if (config()?.subtitle) {
          <span class="iv-subtitle">{{ config()!.subtitle }}</span>
        }
      </div>

      <!-- Controles -->
      <div class="iv-controls">
        <!-- Zoom Out -->
        <button
          class="iv-btn"
          [class.iv-btn--disabled]="!canZoomOut()"
          (click)="zoomOut()"
          title="Alejar (−)">
          <i class="pi pi-search-minus"></i>
        </button>

        <!-- Indicador de escala -->
        <span class="iv-scale-badge">{{ (scale() * 100).toFixed(0) }}%</span>

        <!-- Zoom In -->
        <button
          class="iv-btn"
          [class.iv-btn--disabled]="!canZoomIn()"
          (click)="zoomIn()"
          title="Acercar (+)">
          <i class="pi pi-search-plus"></i>
        </button>

        <!-- Reset -->
        <button
          class="iv-btn"
          [class.iv-btn--disabled]="!isZoomed() && !isPanned()"
          (click)="resetTransform()"
          title="Restablecer (0)">
          <i class="pi pi-expand"></i>
        </button>

        <!-- Divider -->
        <div class="iv-divider"></div>

        <!-- Descargar -->
        <button
          class="iv-btn iv-btn--download"
          (click)="downloadImage()"
          title="Descargar imagen">
          <i class="pi pi-download"></i>
        </button>

        <!-- Cerrar -->
        <button
          class="iv-btn iv-btn--close"
          (click)="close()"
          title="Cerrar (Esc)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- ── Área de imagen ─────────────────────────────────────────── -->
    <div
      class="iv-image-area"
      [class.iv-image-area--draggable]="isZoomed()"
      [class.iv-image-area--dragging]="isZoomed()"
      (wheel)="onWheel($event)"
      (mousedown)="onMouseDown($event)">

      <img
        #imgRef
        [src]="config()?.url"
        [alt]="config()?.title || 'Imagen'"
        class="iv-image"
        [style.transform]="imgTransform()"
        (dragstart)="$event.preventDefault()" />
    </div>

    <!-- ── Pie con atajos de teclado ─────────────────────────────── -->
    <div class="iv-footer">
      <span class="iv-hint"><kbd>Esc</kbd> Cerrar</span>
      <span class="iv-hint"><kbd>+</kbd><kbd>−</kbd> Zoom</span>
      <span class="iv-hint"><kbd>0</kbd> Restablecer</span>
      <span class="iv-hint"><i class="pi pi-arrows-alt text-2xs"></i> Arrastrar con zoom</span>
    </div>

  </div>
}
